import { Component, inject, OnInit } from '@angular/core';
import { User } from 'api-clients/identity-server-api-client';
import { UserService } from '../../shared/user.service';
import { FooterService } from './footer.service';

@Component({
  selector: 'ez-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [],
  providers: [FooterService],
  host: {
    '[class.login-as]': '!!user?.supportPersonId',
    class: 'mat-typography',
  },
})
export class FooterComponent implements OnInit {
  user: User;
  supportPersonId: string;
  copyright = '© EZLynx. All Rights Reserved';
  server: string;

  readonly #footerService = inject(FooterService);
  readonly #userService = inject(UserService);

  async ngOnInit(): Promise<void> {
    this.user = this.#userService.user;
    this.server = (await this.#footerService.getServerNumber()).serverNumber;
  }
}
